import { ArrayUtil } from "@mcleod/core";
import { Panel, PanelProps } from "@mcleod/components";
import { ExpandButton } from "./ExpandButton";
import { ExamplesPanel } from "./ExamplesPanel";
import { FinalizedExample } from "./FinalizedExample";

export abstract class AbstractLinePanel extends Panel {
    constructor(name: string, def: any, examples: FinalizedExample[], props?: Partial<PanelProps>)
    {
        super({
            borderBottomWidth: 1,
            borderBottomColor: "strokeSecondary",
            fillRow: true,
            rowBreakDefault: false,
            ...props
        });
        this.build(name, def);
        this.addExamples(examples);
    }

    protected abstract build(name?: string, def?: any): void;

    private addExamples(examples: FinalizedExample[]) {
        if (ArrayUtil.isEmptyArray(examples))
            return;
        const expandButton = new ExpandButton(this, false, { rowBreak: true, preventCollapse: true, width: null });
        this.add(expandButton);
        const examplePanel = new ExamplesPanel(examples);
        this.add(examplePanel);
    }
}
